// The last few versions of each page the server sent this tab, by revision. A save refused as stale (409) merges
// onto the newer page from the version it was built on, which must be the server's exact copy (utils/offlineMerge).

import type { drawingPage } from 'reduxStore/projects/types'

const KEPT_PER_PAGE = 8

const versions = new Map<string, Map<number, drawingPage>>()

export const revisionOf = (page: Pick<drawingPage, 'revision'>) => page.revision ?? 0

export function rememberServerPage(page: drawingPage | undefined): void {
  if (!page?.id) return
  const kept = versions.get(page.id) ?? new Map<number, drawingPage>()
  kept.set(revisionOf(page), page)
  while (kept.size > KEPT_PER_PAGE) kept.delete(Math.min(...kept.keys()))
  versions.set(page.id, kept)
}

export const serverPageAt = (pageId: string, revision: number) => versions.get(pageId)?.get(revision)

export const forgetServerPages = () => versions.clear()
